var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Checkbox, ListItemText, MenuItem, Select } from '@mui/material';
import { selectorMenuProps } from './utils';
import { checkedIcon, indeterminateIcon, uncheckedIcon } from '../../../autocompleteSelector/AutocompleteSelectorListItem';
var ALL_OPTIONS_FILTER = '';
var NULL_OPTION_VALUE = 'IS NULL';
var getLabelForOption = function (option) { return typeof (option === null || option === void 0 ? void 0 : option.label) !== 'undefined' ? option === null || option === void 0 ? void 0 : option.label : option === null || option === void 0 ? void 0 : option.value; };
var EnumFilter = function (_a) {
    var enumColumn = _a.enumColumn, onFilterChange = _a.onFilterChange;
    var enumFilterOptions = enumColumn.options
        .map(function (option) { return (__assign(__assign({}, option), { value: option.value === null ? NULL_OPTION_VALUE : String(option.value) })); });
    var allValues = enumFilterOptions.map(function (option) { return String(option.value); });
    var noOptionsFilter = '-=' + allValues.join(';');
    var selectedValues = !(enumColumn === null || enumColumn === void 0 ? void 0 : enumColumn.filter) || enumColumn.filter === ALL_OPTIONS_FILTER ? allValues
        : enumColumn.filter === noOptionsFilter ? []
            : enumColumn.filter.split(';');
    var areAllOptionsSelected = selectedValues.length === enumFilterOptions.length;
    var areNoOptionsSelected = selectedValues.length === 0;
    var onToggleOption = function (optionValue) {
        if (selectedValues.includes(optionValue)) {
            updateFilterValue(selectedValues.filter(function (selectedValue) { return selectedValue !== optionValue; }));
        }
        else {
            updateFilterValue(__spreadArray(__spreadArray([], selectedValues, true), [optionValue], false));
        }
    };
    var onToggleSelectAll = function () {
        if (areAllOptionsSelected) {
            updateFilterValue([]);
        }
        else {
            updateFilterValue(__spreadArray([], allValues, true));
        }
    };
    var updateFilterValue = function (newSelectedValues) {
        var newFilterValue = newSelectedValues.length === allValues.length ? ALL_OPTIONS_FILTER
            : newSelectedValues.length === 0 ? noOptionsFilter
                : newSelectedValues.join(';');
        if (enumColumn.filter !== newFilterValue) {
            onFilterChange(enumColumn, newFilterValue);
        }
    };
    var getRenderValue = function () {
        return areAllOptionsSelected
            ? 'All'
            : enumFilterOptions
                .filter(function (option) { return selectedValues.includes(option.value); })
                .map(getLabelForOption)
                .join('; ');
    };
    return (React.createElement(Select, { className: "columnFilter enumFilter", multiple: true, fullWidth: true, displayEmpty: true, disableUnderline: true, MenuProps: selectorMenuProps, disabled: !enumColumn.filterable, value: [], renderValue: getRenderValue },
        !enumColumn.hideAllOption &&
            React.createElement(MenuItem, { key: "enumFilter-ALL", value: '', onClick: onToggleSelectAll, divider: true },
                React.createElement(Checkbox, { icon: uncheckedIcon, checkedIcon: checkedIcon, indeterminateIcon: indeterminateIcon, indeterminate: !areAllOptionsSelected && !areNoOptionsSelected, checked: areAllOptionsSelected }),
                React.createElement(ListItemText, { primary: 'All' })),
        enumFilterOptions.map(function (option) {
            return React.createElement(MenuItem, { key: "enumFilter" + option.value, value: option.value, onClick: function () { return onToggleOption(String(option.value)); } },
                React.createElement(Checkbox, { icon: uncheckedIcon, checkedIcon: checkedIcon, checked: selectedValues.includes(String(option.value)) }),
                React.createElement(ListItemText, { primary: getLabelForOption(option) }));
        })));
};
export default EnumFilter;
//# sourceMappingURL=EnumFilter.js.map